<template>
  <span
    :class="[
      'inline-flex items-center gap-1.5 font-mono text-[10.5px] uppercase tracking-wide',
      'px-2 py-0.5 rounded border',
      toneClasses,
    ]"
  >
    <span v-if="dot" :class="['w-1.5 h-1.5 rounded-full', dotClasses]"></span>
    <slot>{{ label }}</slot>
  </span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  status: { type: String, required: true }, // running | stale | ok | error | inactive | pending
  label:  { type: String, default: '' },
  dot:    { type: Boolean, default: false },
});

const map = {
  running:  { tone: 'lime',  dot: 'bg-lime' },
  ok:       { tone: 'ok',    dot: 'bg-ok' },
  stale:    { tone: 'warn',  dot: 'bg-warn' },
  pending:  { tone: 'warn',  dot: 'bg-warn' },
  error:    { tone: 'err',   dot: 'bg-err' },
  inactive: { tone: 'muted', dot: 'bg-text-3' },
};

const toneClasses = computed(() => ({
  lime:  'bg-[rgba(184,230,0,0.08)] text-lime border-[rgba(184,230,0,0.35)]',
  ok:    'bg-[rgba(74,222,128,0.08)] text-ok border-[rgba(74,222,128,0.35)]',
  warn:  'bg-[rgba(245,165,36,0.08)] text-warn border-[rgba(245,165,36,0.35)]',
  err:   'bg-[rgba(240,82,82,0.08)] text-err border-[rgba(240,82,82,0.35)]',
  muted: 'bg-transparent text-text-3 border-line-2',
}[map[props.status]?.tone || 'muted']));

const dotClasses = computed(() => map[props.status]?.dot || 'bg-text-3');
</script>
